import generateUUID from '@picsart/rc/generateUUID';
import { TemplateCategoryModel } from 'templates/types';

const TemplateItemDefault = {
  _id: '',
  created: '',
  description: '',
  display_name: '',
  has_children: false,
  hashtags: [],
  imageUrl: '',
  image_type: '',
  is_live: false,
  item_id: '',
  long_content: [],
  long_description: '',
  name: '',
  meta_title: '',
  short_text: '',
  meta_description: '',
  template_hashtags: [],
  title: '',
  updated: '',
};

const TOP_TEMPLATE_ITEM_TEXT_CONTENTS = {
  shortText:
    '<p>It’s easy to create art with graphic design templates. Choose from stunning templates made by professional designers and edit them with just a few clicks. You don’t even need any design skills to create something stunning with free design templates from Picsart.<br></p>',
  long_content: [
    {
      _id: generateUUID(),
      long_text_title: 'Free Design Templates for Any Occasion',
      description:
        '<p>Browse the Picsart template collection, and you’ll find templates for every occasion in a range of design styles. A professional graphics team creates free templates based on all the latest colors and style trends. Templates are often updated with designs for the current season, holidays, and other trending-of-the-moment topics.<br/><br/>' +
        '\n\n' +
        'Creators choose templates to get their projects done fast without professional help. You can use templates and make a few changes, or as many as you like. Intuitive editing tools make it easy for you to change colors, texts, fonts, and images. So, you’re free to add your graphics or choose from the Picsart collection of backgrounds, photos, and stickers.<br/><br/>' +
        '\n' +
        'When you finish editing your design template you can export it in high resolution. Professional designers make sure that Picsart templates are the right sizes for your social media posts, profiles, ads, and banners. And, free printable templates for business cards, postcards, flyers, and brochures are also right-sized and ready to export and print.<br/><br/>' +
        '\n' +
        'Templates are great for business owners or if you post to social media for your job. You’ll find the right Picsart templates that will help you communicate and advertise online and off.<br/>' +
        '\n' +
        'Individuals can also have fun and express their creativity with Picsart templates. Using intuitive editorial tools, you can take your selfies and pet photos to new levels. If you have an upcoming event like a baby shower, birthday party, or wedding, use printable templates to make one-of-a-kind invitations.<br/><br/>' +
        '\n' +
        'Enjoy creating engaging personal and professional posts quickly. Start with an inspiring free Picsart template and let your design ideas shine.\n</p>',
    },
  ],
};

const TOP_TEMPLATE_ITEM: Array<TemplateCategoryModel> = [
  {
    ...TemplateItemDefault,
    item_id: 'templates',
    description: '',
    display_name: 'Free Design Templates',
    name: 'templates',
    long_content: TOP_TEMPLATE_ITEM_TEXT_CONTENTS.long_content,
    short_text: TOP_TEMPLATE_ITEM_TEXT_CONTENTS.shortText,
    title: 'Templates',
    image_type: '',
    image_url: '',
  },
];

export default TOP_TEMPLATE_ITEM;
